import env from '@polleverywhere/core/lib/env'

export const RAILS = env.get('graphql_url').toString()
export const CONDUIT = env.get('api_server_url').path('graphql-ws').toString()
export const CONDUIT_LONGPOLL = env.get('api_server_url').protocol('https').path('graphql-ws/longpoll').toString()
